/**
 * FikoMalzemeKarsilastir — Malzeme/Maliyet/CO2 Karşılaştırma motoru
 * Aktif modelin hacmi → her malzemede ağırlık + hammadde maliyeti + karbon ayak izi.
 * Malzeme seçimi + sürdürülebilirlik (ESG) kararı için.
 */
import { MALZEMELER } from '../fiko-mass-info/FikoMassInfo';
import { MALZEME_PIYASA } from '../fiko-teklif/FikoTeklif';

/** Beşikten-kapıya yaklaşık karbon ayak izi (kg CO₂e / kg malzeme). */
export const MALZEME_CO2: Record<string, number> = {
  'Alüminyum': 9.0, 'Çelik': 2.0, 'Paslanmaz Çelik': 6.0, 'Bakır': 4.0, 'Pirinç': 3.5,
  'Bronz': 4.0, 'Titanyum': 35.0, 'PLA Plastik': 2.0, 'ABS Plastik': 3.5, 'Naylon': 7.0,
  'Cam': 1.0, 'Ahşap (Meşe)': 0.2, 'Özel': 2.0,
};

export interface MalzemeSatir {
  ad: string;
  yogunluk: number;       // kg/dm³
  agirlikKg: number;
  fiyatKg: number;        // ₺/kg
  maliyet: number;        // ₺ (hammadde)
  co2Kg: number;          // kg CO₂e
  enUcuz?: boolean;
  enYesil?: boolean;
  enHafif?: boolean;
}

/** Hacim (cm³) ve fire payı ile tüm malzemeleri karşılaştır → sıralı satırlar. */
export function malzemeKarsilastir(hacimCm3: number, fireYuzde = 0): MalzemeSatir[] {
  const dm3 = hacimCm3 / 1000;
  const carpan = 1 + (fireYuzde || 0) / 100;
  const satirlar: MalzemeSatir[] = MALZEMELER.filter(m => m.ad !== 'Özel').map(m => {
    const agirlikKg = dm3 * m.yogunluk * carpan;
    const fiyatKg = MALZEME_PIYASA[m.ad]?.fiyatKg ?? 100;
    const co2 = MALZEME_CO2[m.ad] ?? 2;
    return { ad: m.ad, yogunluk: m.yogunluk, agirlikKg, fiyatKg, maliyet: agirlikKg * fiyatKg, co2Kg: agirlikKg * co2 };
  });
  if (satirlar.length) {
    const ucuz = satirlar.reduce((a, b) => b.maliyet < a.maliyet ? b : a); ucuz.enUcuz = true;
    const yesil = satirlar.reduce((a, b) => b.co2Kg < a.co2Kg ? b : a); yesil.enYesil = true;
    const hafif = satirlar.reduce((a, b) => b.agirlikKg < a.agirlikKg ? b : a); hafif.enHafif = true;
  }
  return satirlar.sort((a, b) => a.maliyet - b.maliyet);
}
